import { Platform } from "@linkfluence/models/platform";
import { FullInfluencer } from "@radarly/models/influencer";
import { RadarlyAPI } from "./base";

export class InfluencerAPI extends RadarlyAPI {
  /**
   * Get influencer from Radarly influencer id (platform context included)
   * @param influencerId e.g. r3_prod-tw-825030437676388352
   */
  public async getInfluencerFromUid(projectId: number, influencerId: string) {
    return await this.get<FullInfluencer>(
      `/projects/${projectId}/influencer/${influencerId}.json`
    );
  }

  /**
   * Get influencer from influencer id and its platform
   * @param uid e.g. 825030437676388352
   */
  public async getInfluencer(
    projectId: number,
    platform: Platform,
    uid: string
  ) {
    return await this.get<FullInfluencer>(
      `/projects/${projectId}/influencer.json?platform=${platform}&uid=${uid}`
    );
  }
}
